import { z } from 'zod'

import {
  VenueBillingCycle,
  VenueBillingManageAction,
  VenueBillingPaymentStatus,
  VenueBillingSignupStatus,
} from '../constants/venueBilling'
import { addressInputSchema } from './system'

export const venueBillingCheckoutAddonsSchema = z.object({
  posIntegration: z.boolean().optional(),
  customerChat: z.boolean().optional(),
})

export const venueBillingCheckoutPostBodySchema = z.object({
  billingCycle: z.nativeEnum(VenueBillingCycle),
  selectedPlanCode: z.string().min(1).optional(),
  subscriberFirstName: z.string().trim().min(1).optional(),
  subscriberLastName: z.string().trim().min(1).optional(),
  subscriberEmail: z.string().email().optional(),
  venueAddress: addressInputSchema.optional(),
  billingAddress: addressInputSchema.optional(),
  addons: venueBillingCheckoutAddonsSchema.optional(),
  returnPath: z
    .string()
    .regex(/^\/[\w\-./?&=%]*$/)
    .optional(),
})

export const venueBillingCheckoutResponseSchema = z.object({
  checkoutUrl: z.string().url(),
  signupStatus: z.nativeEnum(VenueBillingSignupStatus).optional(),
  paymentStatus: z.nativeEnum(VenueBillingPaymentStatus).optional(),
  statusReason: z.string().nullable().optional(),
})

export const venueBillingManagePostBodySchema = z.object({
  action: z.nativeEnum(VenueBillingManageAction),
  billingCycle: z.nativeEnum(VenueBillingCycle).optional(),
  addons: venueBillingCheckoutAddonsSchema.optional(),
  returnPath: z
    .string()
    .regex(/^\/[\w\-./?&=%]*$/)
    .optional(),
})

export const venueBillingManageResponseSchema = z.object({
  checkoutUrl: z.string().url(),
})

export const venueBillingCatalogResponseSchema = z.object({
  monthlyPrice: z.number().nullable(),
  yearlyPrice: z.number().nullable(),
  currencyCode: z.string(),
})

export const venueBillingInvoiceSchema = z.object({
  id: z.string(),
  number: z.string().nullable(),
  date: z.string().nullable(),
  status: z.string().nullable(),
  total: z.number().nullable(),
  balance: z.number().nullable(),
  currencyCode: z.string().nullable(),
  viewUrl: z.string().url().nullable(),
})

export const venueBillingInvoicesListResponseSchema = z.object({
  invoices: z.array(venueBillingInvoiceSchema),
})

export type VenueBillingCheckoutPostBody = z.infer<
  typeof venueBillingCheckoutPostBodySchema
>

export type VenueBillingCheckoutResponse = z.infer<
  typeof venueBillingCheckoutResponseSchema
>

export type VenueBillingManagePostBody = z.infer<
  typeof venueBillingManagePostBodySchema
>

export type VenueBillingManageResponse = z.infer<
  typeof venueBillingManageResponseSchema
>

export type VenueBillingCatalogResponse = z.infer<
  typeof venueBillingCatalogResponseSchema
>

export type VenueBillingInvoice = z.infer<typeof venueBillingInvoiceSchema>

export type VenueBillingInvoicesListResponse = z.infer<
  typeof venueBillingInvoicesListResponseSchema
>
